import { render, staticRenderFns } from "./petshop.vue?vue&type=template&id=0ab79983&scoped=true&"
import script from "./petshop.vue?vue&type=script&lang=js&"
export * from "./petshop.vue?vue&type=script&lang=js&"
import style0 from "./petshop.vue?vue&type=style&index=0&id=0ab79983&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab79983",
  null
  
)

export default component.exports